"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "button", "value", "itemValue", "className"];

var MenuItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
      button = props.button,
      value = props.value,
      itemValue = props.itemValue,
      className = props.className,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, otherProps, {
    ref: ref,
    value: value ? value : itemValue,
    button: button ? true : undefined,
    className: (0, _classnames.default)("prmbl-menuItem", className)
  }), children);
});

exports.MenuItem = MenuItem;
MenuItem.displayName = "MenuItem";
MenuItem.defaultProps = {
  button: true
};
var _default = MenuItem;
exports.default = _default;